import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";
import {
  frameMentionOptionsFromSources,
  type FrameMentionSource,
} from "@/lib/frame-mentions";
import { useFramesStore } from "@/stores/frames-store";

function sourceKey(source: FrameMentionSource): string {
  return JSON.stringify([
    source.frame_id,
    source.title ?? "",
    source.frame_type,
  ]);
}

function sourceFromKey(key: string): FrameMentionSource {
  const [frame_id, title, frame_type] = JSON.parse(key) as [
    string,
    string,
    string,
  ];
  return { frame_id, title, frame_type };
}

export function useFrameMentionOptions() {
  const sourceKeys = useFramesStore(
    useShallow((s) =>
      s.frameOrder.map((id) => {
        const frame = s.framesById[id]!;
        return sourceKey({
          frame_id: id,
          title: frame.title,
          frame_type: frame.frameType,
        });
      }),
    ),
  );

  return useMemo(
    () => frameMentionOptionsFromSources(sourceKeys.map(sourceFromKey)),
    [sourceKeys],
  );
}
